import constants from '../constants';

export function requestReceipts() {
    return {
        meta: {
            remote: false,
        },
        type: constants.RECEIPTS_REQUEST,
    };
}

export function receiveReceipts(receipts) {
    return {
        meta: {
            remote: false,
        },
        type: constants.RECEIVE_RECEIPTS,
        payload: {
            receipts: receipts,
            receivedAt: Date.now(),
        },
    };
}

export function changeReceiptFromDate(date) {
    return {
        meta: {
            remote: false,
        },
        payload: {
            from: date,
        },
        type: constants.RECEIPT_FROM_FILTER_CHANGE,
    };
}

export function changeReceiptToDate(date) {
    return {
        meta: {
            remote: false,
        },
        payload: {
            to: date,
        },
        type: constants.RECEIPT_TO_FILTER_CHANGE,
    };
}

export function changeReceiptFilterType(type) {
    return {
        meta: {
            remote: false,
        },
        payload: {
            filterByType: type,
        },
        type: constants.RECEIPT_FILTER_TYPE_CHANGE,
    };
}

export function changeReceiptUserFilter(user) {
    return {
        meta: {
            remote: false,
        },
        payload: {
            user: user,
        },
        type: constants.RECEIPT_FILTER_USER_CHANGE,
    };
}

export function changeReceiptBranchFilter(branch) {
    return {
        meta: {
            remote: false,
        },
        payload: {
            branch: branch,
        },
        type: constants.RECEIPT_FILTER_BRANCH_CHANGE,
    };
}

export function selectedReceipts(
    receipts,
    options = { selectBranch: false, selectDuplicates: false, selectPrinted: false }
) {
    return {
        meta: {
            remote: false,
        },
        payload: {
            selected_receipts: receipts,
            select_branch: options.selectBranch,
            select_duplicates: options.selectDuplicates,
            select_printed: options.selectPrinted,
        },
        type: constants.SELECTED_RECEIPTS_CHANGE,
    };
}

// export function fetchReceipts (token) {
//   return function (dispatch) {
//     dispatch(requestReceipts());
//     return fetchURL(token, config.apiRoot + config.receipts)
//       .then(checkHttpStatus)
//       .then(response => response.json())
//       .then(function (json) {
//         dispatch(receiveReceipts(json.receipts));
//       }).catch(error => {
//         if (error.response.status === 401) {
//           dispatch(loginUserFailure(error));
//           dispatch(logoutAndRedirect);
//         }
//       });
//   };
// }

// export function fetchReceiptItems (token, receiptId) {
//   return function (dispatch) {
//     dispatch(requestReceipts());
//     return fetchURL(token, config.apiRoot + "" + config.receiptsItems(receiptId))
//       .then(response => response.json())
//       .then(function (json) {
//         dispatch(receiveReceipts(json.receipts));
//       }).catch(error => {
//         if (error.response.status === 401) {
//           dispatch(loginUserFailure(error));
//           dispatch(logoutAndRedirect);
//         }
//       });
//   };
// }
